import React, { useEffect, useState } from 'react';
import heroBg from '../assets/business.webp';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Hero = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    let token;

    if (consent === 'true') {
      token = localStorage.getItem('jwtToken');
    } else {
      token = sessionStorage.getItem('jwtToken');
    }

    setIsLoggedIn(!!token);
  }, []);

  return (
    <section
      className="relative text-white"
      style={{
        backgroundImage: `url(${heroBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Blue Transparent Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#1D3A50]/90 to-[#182F40]/90 z-0" />

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto py-24 md:py-32 px-6">
        <div className="max-w-2xl">
          <p
            className="text-sm md:text-lg mb-2 md:mb-4 font-semibold"
            style={{
              background: 'linear-gradient(135deg, #F2C231, #C69A32)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            BENVENUTO SU CAF ONLINE
          </p>

          <h1 className="text-4xl md:text-6xl font-bold mb-3 md:mb-6 leading-tight">
            RICHIEDI I{' '}
            <span
              style={{
                background: 'linear-gradient(135deg, #F2C231, #C69A32)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              TUOI SERVIZI
            </span>
            <br />
            ONLINE
          </h1>

          <Link
            to="/services"
            state={{ selectedCategory: 'CAF' }}
            className="text-sm md:text-base text-black font-semibold px-2 md:px-8 py-2 md:py-3 rounded-md shadow transition-colors mr-4"
            style={{
              background: 'linear-gradient(135deg, #F2C231, #C69A32)',
            }}
          >
            I NOSTRI SERVIZI
          </Link>

          {!isLoggedIn && (
            <Link
              to="/login"
              className="text-sm md:text-base text-black font-semibold px-2 md:px-8 py-2 md:py-3 rounded-md shadow transition-colors"
              style={{
                background: 'linear-gradient(135deg, #F2C231, #C69A32)',
              }}
            >
              ACCEDI
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;